<template>
  <el-container class="screen-parameters screen-parameters-fullHeight services">
    <el-row class="services-panel black-inputs black-inputs_2">
      <el-col :span="20" :offset="2" class="services-container">
        <div class="nav-toggle" @click="showHideScreenInfos">
          <div id="nav-icon3" class="open"><span></span><span></span><span></span><span></span></div>
        </div>
        <div class="screen-title">Informations génerales</div>
        <div class="screen-block">
          <div class="screen-block">
            <el-row>
              <el-col :span="6" class="screen-label">Nom du restaurant :</el-col>
              <el-col :span="18">
                <el-input v-model="restaurantName"></el-input>
              </el-col>
            </el-row>
          </div>
          <div class="screen-block">
            <el-row>
              <el-col :span="6" class="screen-label">email du restaurant :</el-col>
              <el-col :span="18">
                <el-input v-model="restaurantMail"></el-input>
              </el-col>
            </el-row>
          </div>
          <div class="screen-block">
            <el-row>
              <el-col :span="6" class="screen-label">Téléphone du restaurant :</el-col>
              <el-col :span="18">
                <el-input v-model="restaurantTel"></el-input>
              </el-col>
            </el-row>
          </div>
          <div class="screen-block">
            <el-row>
              <el-col :span="6" class="screen-label">Adresse du restaurant :</el-col>
              <el-col :span="18">
                <el-input v-model="restaurantAdresse"></el-input>
              </el-col>
            </el-row>
          </div>
          <div class="screen-block">
            <el-row>
              <el-col :span="6" class="screen-label">Lien vers le menu :</el-col>
              <el-col :span="18">
                <el-input v-model="restoMenuLink"></el-input>
              </el-col>
            </el-row>
          </div>
          <div class="screen-block">
            <el-row>
              <el-col :span="6" class="screen-label">Id du Google Tag Manager :<br /><span
                  class="screen-label-info">ex: GTM-ABCDE1</span></el-col>
              <el-col :span="18">
                <el-input v-model="googleTagManagerId" placeholder="GTM-ABCDE1"></el-input>
              </el-col>
            </el-row>
          </div>
          <div>
            <div class="screen-title clikable" @click="showMessages = !showMessages">
              Personnaliser les messages <span style="width: 30px; display: inline-block;"></span>
              <i class="el-icon-edit" v-if="!showMessages"></i>
              <i class="el-icon-arrow-up" v-if="showMessages"></i>
            </div>
            <br />
            <div v-if="showMessages">
              <div class="screen-block">
                <el-row>
                  <el-col :span="6" class="screen-label">Message de réservation : <br /><span
                      class="screen-label-info">message supplémentaire
                      lors de l'envoi du mail dès qu'une réservation a été demandée</span></el-col>
                  <el-col :span="18">
                    <el-input v-model="resaMessage" :autosize="{ minRows: 3 }" type="textarea"></el-input>
                  </el-col>
                </el-row>
              </div>
              <div class="screen-block">
                <el-row>
                  <el-col :span="6" class="screen-label">Message client au moment de la réservation : <el-tooltip
                      placement="top" content="Modification possible: **gras** 
                      *italique*  ++souligné++  [mon lien](https://google.com)" popper-class="tooltip">
                      <i class="el-icon-info"></i>
                    </el-tooltip><br /><span class="screen-label-info">message informatif en bas du formulaire de
                      réservation côté client lors
                      de la première étape de celui-ci</span>
                  </el-col>
                  <el-col :span="18">
                    <el-input v-model="restoBookingMessage" :autosize="{ minRows: 3 }" type="textarea" />
                    <div v-if="restoBookingMessage" class="markdown-preview" v-html="renderedBookingMessage" />

                  </el-col>
                </el-row>
              </div>
              <div class="screen-block">
                <el-row>
                  <el-col :span="6" class="screen-label">Message de validation : <br /><span
                      class="screen-label-info">message supplémentaire
                      lors de l'envoi du mail pour une réservation acceptée</span></el-col>
                  <el-col :span="18">
                    <el-input v-model="resaMessageAccepted" :autosize="{ minRows: 3 }" type="textarea"></el-input>
                  </el-col>
                </el-row>
              </div>
              <div class="screen-block">
                <el-row>
                  <el-col :span="6" class="screen-label">Message d'annulation: <br /><span
                      class="screen-label-info">message supplémentaire
                      lors de l'envoi du mail pour une réservation refusée</span></el-col>
                  <el-col :span="18">
                    <el-input v-model="resaMessageCancelled" :autosize="{ minRows: 3 }" type="textarea"></el-input>
                  </el-col>
                </el-row>
              </div>
              <div class="screen-block">
                <el-row>
                  <el-col :span="6" class="screen-label">Message de
                    confirmation: <el-tooltip placement="top" content="Modification possible: **gras** 
                      *italique*  ++souligné++  [mon lien](https://google.com)" popper-class="tooltip">
                      <i class="el-icon-info"></i>
                    </el-tooltip> <br /><span class="screen-label-info">Changer le titre par défaut lors de la fin du
                      formulaire confirmant que la demande du client a bien été reçue</span>
                  </el-col>
                  <el-col :span="18">
                    <el-input placeholder="Bravo ! Votre réservation est acceptée par le restaurateur"
                      v-model="resaMessageConfirm" :autosize="{ minRows: 3 }" type="textarea" />
                    <div v-if="resaMessageConfirm" class="markdown-preview" v-html="renderedConfirmMessage" />
                  </el-col>
                </el-row>
              </div>
              <div class="screen-block">
                <el-row>
                  <el-col :span="6" class="screen-label">Message de prépaiement accepté automatiquement: <el-tooltip
                      placement="top" content="Modification possible: **gras** 
                      *italique*  ++souligné++  [mon lien](https://google.com)" popper-class="tooltip">
                      <i class="el-icon-info"></i>
                    </el-tooltip><br /><span class="screen-label-info">Message de la popup de redirection lorsqu'une
                      réservation avec
                      prépaiement a été acceptée</span><span class="screen-label-info"></span></el-col>
                  <el-col :span="18">
                    <el-input v-model="resaAutoAcceptPrepaiementMessage" :autosize="{ minRows: 3 }" type="textarea" />
                    <div v-if="resaAutoAcceptPrepaiementMessage" class="markdown-preview"
                      v-html="renderedPrepaiementMessage" />
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
          <div class="screen-block">
            <el-row>
              <el-col :span="12">
                <span style="margin-right: 10px">Notifications e-mail pour les réservations externes :</span>
                <el-switch v-model="restoMailSended" active-color="#00cec0" inactive-color="#e95d5d">
                </el-switch>
              </el-col>
              <el-col :span="12">
                <span style="margin-right: 10px">Permanence téléphonique :</span>
                <el-switch v-model="permanenceOn" active-color="#00cec0" inactive-color="#e95d5d">
                </el-switch>
              </el-col>
            </el-row>
            <el-row style="margin-top:20px">
              <el-col :span="12">
                <span style="margin-right: 10px">Réservations classiques et cautions acceptées automatiquement :</span>
                <el-switch v-model="restoAutoAccept" active-color="#00cec0" inactive-color="#e95d5d">
                </el-switch>
              </el-col>
              <el-col :span="12">
                <span style="margin-right: 10px">Réservations avec prépaiement acceptées automatiquement :</span>
                <el-switch v-model="restoAutoAcceptPrepaiement" active-color="#00cec0" inactive-color="#e95d5d">
                </el-switch>
              </el-col>
            </el-row>
            <el-row style="margin-top:20px">
              <el-col :span="24">
                <span style="margin-right: 10px">Relance à 24H des réservations</span>
                <el-switch v-model="restoRelaunch" active-color="#00cec0" inactive-color="#e95d5d">
                </el-switch>
              </el-col>
              <el-col :span="24">
                <el-row style="margin-top:20px" v-if="restoRelaunch">
                  <el-col :span="6" class="screen-label">Message relance à 24H :</el-col>
                  <el-col :span="18">
                    <el-input v-model="restoRelaunchTxt" :autosize="{ minRows: 3 }" type="textarea"></el-input>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row style="margin-top:20px">
              <el-col :span="24">
                <span style="margin-right: 10px">Redirection de confirmation de réservation</span>
                <el-switch v-model="restoResaRedirect" active-color="#00cec0" inactive-color="#e95d5d">
                </el-switch>
              </el-col>
              <el-col :span="24">
                <el-row style="margin-top:20px" v-if="restoResaRedirect">
                  <el-col :span="6" class="screen-label">Liens de redirection :</el-col>
                  <el-col :span="18">
                    <el-input v-model="restoResaRedirectTxt"></el-input>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
          <el-row>
            <el-col :span="7" :offset="9">
              <el-button class="dark" type="primary" @click="showHideScreenInfos">Annuler</el-button>
            </el-col>
            <el-col :span="7" :offset="1">
              <el-button type="primary" @click="validModifications()">Valider</el-button>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
  </el-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { Notification } from 'element-ui';
import { renderMarkdown } from '../../tools/markdownHelper';

export default {
  name: 'InfosRestaurant',
  data() {
    return {
      restaurantName: '',
      restaurantMail: '',
      restaurantTel: '',
      restaurantAdresse: '',
      restoMenuLink: '',
      googleTagManagerId: '',
      resaMessage: '',
      restoBookingMessage: '',
      resaAutoAcceptPrepaiementMessage: '',
      resaMessageAccepted: '',
      resaMessageCancelled: '',
      resaMessageConfirm: '',
      restoMailSended: false,
      permanenceOn: false,
      restoAutoAccept: false,
      restoAutoAcceptPrepaiement: false,
      restoRelaunch: false,
      restoRelaunchTxt: '',
      restoResaRedirect: false,
      restoResaRedirectTxt: '',
      showMessages: false
    }
  },
  mounted() {
    if (!document.getElementById('tooltip')) {
      const style = document.createElement('style')
      style.id = 'tooltip'
      style.innerHTML = `
      .tooltip {
        background: #ffffff !important;
        color: #333333 !important;
        box-shadow: 0 2px 8px rgba(0,0,0,0.15);
      }
      .tooltip .popper__arrow {
        display: none;
      }
    `
      document.head.appendChild(style)
    }
  },
  created: function () {
    let data = this.getAllInfos
    if (data.restoName !== undefined) this.restaurantName = data.restoName
    if (data.restoMail !== undefined) this.restaurantMail = data.restoMail
    if (data.restoTel !== undefined) this.restaurantTel = data.restoTel
    if (data.restoAdresse !== undefined) this.restaurantAdresse = data.restoAdresse
    if (data.restoMenuLink !== undefined) this.restoMenuLink = data.restoMenuLink
    if (data.googleTagManagerId !== undefined) this.googleTagManagerId = data.googleTagManagerId
    if (data.resaFirstMessage !== undefined) this.resaMessage = data.resaFirstMessage
    if (data.restoBookingMessage !== undefined) this.restoBookingMessage = data.restoBookingMessage
    if (data.resaAutoAcceptPrepaiementMessage !== undefined) this.resaAutoAcceptPrepaiementMessage = data.resaAutoAcceptPrepaiementMessage
    if (data.resaAcceptedMessage !== undefined) this.resaMessageAccepted = data.resaAcceptedMessage
    if (data.resaCancelledMessage !== undefined) this.resaMessageCancelled = data.resaCancelledMessage
    if (data.resaConfirmMessage !== undefined) this.resaMessageConfirm = data.resaConfirmMessage
    if (data.restoMailSended !== undefined) this.restoMailSended = data.restoMailSended
    if (data.permanenceOn !== undefined) this.permanenceOn = data.permanenceOn
    if (data.restoAutoAccept !== undefined) this.restoAutoAccept = data.restoAutoAccept
    if (data.restoAutoAcceptPrepaiement !== undefined) this.restoAutoAcceptPrepaiement = data.restoAutoAcceptPrepaiement
    if (data.restoResaRedirect !== undefined) this.restoResaRedirect = data.restoResaRedirect
    if (data.restoResaRedirectTxt !== undefined) this.restoResaRedirectTxt = data.restoResaRedirectTxt
    if (data.restoRelaunch !== undefined) this.restoRelaunch = data.restoRelaunch
    if (data.restoRelaunchTxt !== undefined) this.restoRelaunchTxt = data.restoRelaunchTxt
  },
  computed: {
    ...mapGetters({
      getUser: 'newUsers/getUser',
      getAllInfos: 'infos/getAllInfos'
    }),
    renderedBookingMessage() {
      return renderMarkdown(this.restoBookingMessage)
    },
    renderedConfirmMessage() {
      return renderMarkdown(this.resaMessageConfirm)
    },
    renderedPrepaiementMessage() {
      return renderMarkdown(this.resaAutoAcceptPrepaiementMessage)
    }
  },
  methods: {
    ...mapActions({
      showHideScreenInfos: 'displayer/showHideScreenInfos',
      updateInfos: 'infos/updateInfos'
    }),
    validModifications: function () {
      if (this.googleTagManagerId && !/^GTM-[A-Z0-9]{4,10}$/i.test(this.googleTagManagerId)) {
        Notification.error({
          title: 'Google Tag Manager',
          message: 'Format invalide. Utilisez un id du type GTM-ABCDE1.',
          position: 'bottom-right'
        })
        return
      }

      let datas = {
        restoName: this.restaurantName,
        restoMail: this.restaurantMail,
        restoTel: this.restaurantTel,
        restoAdresse: this.restaurantAdresse,
        restoMenuLink: this.restoMenuLink,
        googleTagManagerId: this.googleTagManagerId,
        resaFirstMessage: this.resaMessage,
        resaAutoAcceptPrepaiementMessage: this.resaAutoAcceptPrepaiementMessage,
        resaAcceptedMessage: this.resaMessageAccepted,
        resaCancelledMessage: this.resaMessageCancelled,
        resaConfirmMessage: this.resaMessageConfirm,
        restoMailSended: this.restoMailSended,
        permanenceOn: this.permanenceOn,
        restoAutoAccept: this.restoAutoAccept,
        restoAutoAcceptPrepaiement: this.restoAutoAcceptPrepaiement,
        restoRelaunch: this.restoRelaunch,
        restoRelaunchTxt: this.restoRelaunchTxt,
        restoResaRedirect: this.restoResaRedirect,
        restoResaRedirectTxt: this.restoResaRedirectTxt,
        restoBookingMessage: this.restoBookingMessage
      }
      this.updateInfos(datas)
      this.showHideScreenInfos()
    }
  }
}
</script>

<style lang="scss">
.clikable {
  cursor: pointer;
}

.markdown-preview {
  font-weight: normal;
  white-space: pre-wrap;
}
</style>
